import React, { useState } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../router/all_routes";
import CollapseHeader from "../../core/common/collapse-header/collapse-header";
import { McitiImg } from "../../utils/iconLogo";

const ViewLessionPlan = () => {
  const [resError, setResError] = useState({});
  const [loading, setLoading] = useState(false);

  const columns = [
    { title: "S.No", dataIndex: "key", key: "key" },
    { title: "Subject", dataIndex: "subject", key: "subject" },
    { title: "Given By", dataIndex: "givenBy", key: "givenBy" },
    {
      title: "Lecture Start Time",
      dataIndex: "lectureStartTime",
      key: "lectureStartTime",
    },
    {
      title: "Lecture End Time",
      dataIndex: "lectureEndTime",
      key: "lectureEndTime",
    },
    { title: "Date", dataIndex: "date", key: "date" },
    { title: "Due Date", dataIndex: "dueDate", key: "dueDate" },
    { title: "Description", dataIndex: "description", key: "description" },
    { title: "File Name", dataIndex: "fileName", key: "fileName" },
  ];

  return (
    <>
      <>
        {/* Page Wrapper */}
        <div className="page-wrapper">
          <div className="content">
            {/* Breadcrumb */}
            <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
              <div className="my-auto mb-2">
                <h2 className="mb-1">View Lesson Plan</h2>
                <nav>
                  <ol className="breadcrumb mb-0">
                    <li className="breadcrumb-item">
                      <Link to={all_routes.adminDashboard}>
                        <i className="ti ti-smart-home" />
                      </Link>
                    </li>
                    <li className="breadcrumb-item">Teacher</li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Lesson Plan
                    </li>
                  </ol>
                </nav>
              </div>
              <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
                <div className="ms-2 head-icons">
                  <CollapseHeader />
                </div>
              </div>
            </div>
            {/* /Breadcrumb */}

            <div className="card">
              <div className="card-body p-3">
                <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                  <h5>Lesson Plan</h5>
                </div>
              </div>
            </div>
          </div>
          <div className="footer d-smflex d-flex align-items-center justify-content-center border-top bg-white p-3 pb-0 pt-2">
            <p className="mb-0">
               Organized by IHFC, IIT 
              <img
                src={McitiImg}
                alt="Mciti Logo"
                className="ms-2 "
                style={{
                  height: "40px",
                  width: "40px",
                  objectFit: "contain",
                }}
              />
            </p>
            {/* <p className="mb-0">  © {new Date()?.getFullYear()} IHFC. All rights reserved.</p> */}
          </div>
        </div>
        {/* /Page Wrapper */}
      </>
    </>
  );
};

export default ViewLessionPlan;
